import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ModalWrapper, ModalHeader, ModalBody, ModalFooter } from '../../../../components/ui/modal-wrapper';
const ConfirmDialog = ({ isOpen, data, onClose }) => {
    if (!isOpen || !data)
        return null;
    const { title = 'Confirm action', message, confirmText = 'Yes', cancelText = 'Cancel', onConfirm, onCancel, variant = 'default' } = data;
    const handleConfirm = () => {
        onConfirm?.();
        onClose();
    };
    const handleCancel = () => {
        onCancel?.();
        onClose();
    };
    const confirmButtonClass = variant === 'destructive'
        ? 'bg-destructive text-destructive-foreground hover:bg-destructive/90'
        : 'bg-primary text-primary-foreground hover:bg-primary/90';
    return (_jsxs(ModalWrapper, { size: "sm", children: [_jsx(ModalHeader, { onClose: handleCancel, children: title }), _jsx(ModalBody, { children: _jsx("p", { className: "text-sm text-muted-foreground", children: message }) }), _jsxs(ModalFooter, { children: [_jsx("button", { type: "button", onClick: handleCancel, className: "inline-flex items-center justify-center rounded-md text-sm font-medium h-9 px-4 py-2 border border-input bg-background hover:bg-accent hover:text-accent-foreground transition-colors", children: cancelText }), _jsx("button", { type: "button", onClick: handleConfirm, className: `inline-flex items-center justify-center rounded-md text-sm font-medium h-9 px-4 py-2 transition-colors ${confirmButtonClass}`, children: confirmText })] })] }));
};
export default ConfirmDialog;
